// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"8c6c50a0","140":"c66b13ea","145":"d9bf6ba1","198":"aca2578d","490":"2caeb1a2","887":"071e41c8"}[chunkId] + ".chunk.js";
};